/** Formatters compartidos entre la tabla resumen (AnalysisHubPage) y la ficha imprimible (FichaPage) — notación es-AR (coma decimal). */

export function formatKm(value: number | null): string {
  if (value === null) return '—';
  return `${value.toFixed(1).replace('.', ',')} km`;
}

export function formatMin(value: number | null): string {
  if (value === null) return '—';
  return `${value.toFixed(1).replace('.', ',')} min`;
}

export function formatFleet(value: number | null): string {
  if (value === null) return '—';
  return `${value} unid.`;
}

export function formatPct(value: number | null): string {
  if (value === null) return '—';
  return `${value.toFixed(1).replace('.', ',')}%`;
}

export function formatPopulation(value: number | null | undefined): string {
  if (value == null) return '—';
  return value.toLocaleString('es-AR');
}
